import { Loader, Skeleton } from '@mantine/core'
import { translate } from 'i18n/i18n'

export const WeeklyIrrigationOverviewSkeleton = () => (
  <div>
    <div css={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 40 }}>
      <h3 css={{ margin: 0 }}>{translate.phrases.banyanApp('Planned vs Applied')}</h3>
      <Loader size="sm" color="blue" />
    </div>
    <div css={{ display: 'flex', justifyContent: 'space-between', gap: 20 }}>
      <Skeleton height={250} style={{ flex: 1 }} radius="sm" animate />
      <Skeleton height={250} style={{ flex: 1 }} radius="sm" animate />
      <Skeleton height={250} style={{ flex: 1 }} radius="sm" animate />
    </div>
    <Skeleton height={60} mt={20} radius="sm" animate />
  </div>
)
